var styleDataHash = "57e359b2";
const injectCss = (() => {
  var css = `.nhnUn{--wds-form-field-label-gap-small:9px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var settings_component_default = {
  "formField": "nhnUn"
};
export {
  settings_component_default as default,
  injectCss
};
//# sourceMappingURL=settings-component-scss.js.map
